<script>
	export let tasks = [];
	import ThoughtCard from "./ThoughtCard.svelte";
	//let thougthsTasks = [];
	console.log("so far I got ", tasks);
</script>

<div class="bx--grid">
	<div class="bx--row">
		{#each tasks.slice(0, 500) as task}
		<div class="bx--col">
		<div class="outside">
		  <div class="inside"><ThoughtCard data={task} /></div>
		</div>
	  </div>
	  {/each}
	</div>
  </div>

<!-- <div class="col">
	<div class="row row-cols-1 row-cols-md-2 g-4">
		{#each tasks.slice(0, 500) as task}
			<ThoughtCard data={task} />
		{/each}
	</div>
</div> -->
